var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v(_vm._s(_vm.$t(_vm.menuName)))]),_c('keep-alive',[_c('em-breadcrumb',{ref:"emBreadCrumb",attrs:{"breadcrumbItems":_vm.breadcrumbItems}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }